import * as React from "react";
import { Switch, makeStyles } from "@fluentui/react-components";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    "& input": {
      height: "100%",
      width: "100%",
    },
    "& label": {
      color: "black !important",
    }
  },
});

export const FluentSwitch = ({ label, checked, onChange, disabled, size = "medium" }) => {
  const styles = useStyles();

  return (
    <div className="text-left">
        <Switch
          size={size}
          label={label}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={styles.root}
        />
    </div>
  );
};

FluentSwitch.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};
